import type { AddressResponse, CityResponse } from '@/core/generated/api';
import { FormDetails } from '@/shared/ui/FormDetails/FormDetails';
import type { KeyValueDataObject } from '@/shared/ui/KeyValueRow/KeyValueRow';

interface AddressViewProps {
    address?: AddressResponse;
    city?: CityResponse | null;
}

/** Отображает сведения об адресе */
export const AddressView = ({ address, city }: AddressViewProps) => {
    const data: KeyValueDataObject[] = [
        {
            label: 'Город',
            value: city?.value ?? address?.cityName ?? 'Не указан',
        },
        {
            label: 'Улица',
            value: address?.street || 'Не указана',
        },
        {
            label: 'Дом',
            value: address?.houseNumber || 'Не указан',
        },
        {
            label: 'Подъезд',
            value: address?.entranceToHouse || 'Не указан',
        },
        {
            label: 'Домофон',
            value: address?.domophone || 'Не указан',
        },
        {
            label: 'Этаж',
            value: address?.floor || 'Не указан',
        },
        {
            label: 'Квартира',
            value: address?.apartmentNumber || 'Не указана',
        },
        {
            label: 'Дополнительный комментарий',
            value: address?.additionalComments || 'Не указан',
        },
    ];

    return <section aria-labelledby="address-details-title">
        <h2 id="address-details-title">Адрес</h2>
        <FormDetails dataForShow={data} />
    </section>;
};
